import { CookieUtils } from 'wa-storybook/components/cookie-policy/utils';

const CookiePreferencesInstance = new CookieUtils('hermes');

export default CookiePreferencesInstance;
